<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="no-padding">
      {{ log.parties.Party[1].Number }}
      <q-icon name="arrow_right_alt" size="lg"/>
      {{ log.parties.Party[0].Number }}
      <q-btn flat icon="cloud_download" round @click="playRecordedVoice"/>
    </q-card-section>
    <q-card-section class="no-padding">
      <audio preload="auto" src="" style="width: 100%" :id="audioId" controls
             v-if="$store.state.roles.some(v=>['admin','can_play_recoded_voice'].includes(v))">
        <source :id="sourceId" src="" type="audio/mpeg"/>
      </audio>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "CallLogInfo",
  props: ['log'],
  data() {
    return {
      played: false,
      au: undefined,
      blobUrl: undefined
    }
  },
  computed: {
    audioId: function () {
      const fileName = this.log.filename.split('.').slice(0, -1);
      return `${fileName}-audio`;
    },
    sourceId: function () {
      const fileName = this.log.filename.split('.').slice(0, -1);
      return `${fileName}source`;
    }
  },
  methods: {
    ...mapActions({
      GetCustomerPlayVoice: 'Customers/get_customer_phone_voice'
    }),
    playRecordedVoice() {
      this.played = true;
      this.GetCustomerPlayVoice(this.log.filename).then((res) => {
        let bl = new Blob([res.data], {type: 'audio/mp3;'});
        this.blobUrl = URL.createObjectURL(bl);
        const audio = document.getElementById(this.audioId)
        document.getElementById(this.sourceId).setAttribute('src', this.blobUrl);
        audio.setAttribute('src', this.blobUrl);
        audio.load();
        audio.oncanplaythrough = document.getElementById(this.audioId).play();
      })
    },
  }
}
</script>

<style scoped>

</style>